function reducer(state = [], action) {
  // call saga to fetch the leagues from API ?
  switch (action.type) {
    case 'SIZES/SET':
      return action.sizes;
    case 'SIZES/CLEAR':
      return null;
    default:
      return state;
  }
}

export default reducer;